import Vue from 'vue'
import VueRouter from 'vue-router'
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import store from '@/store'
import Home from '@/views/modules/skeleton/Home.vue'
import dashboard from './routes/dashboard'
import pages from './routes/pages'
import skeleton from './routes/skeleton'
import experiments from './routes/experiments'
import categories from './routes/categories'
import institutions from './routes/institutions'
import chatbot from './routes/chatbot'
import versions from './routes/versions'
import roles from './routes/roles'
import logs from './routes/logs'
import lms from './routes/lms'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'home' } },
    ...dashboard,
    ...skeleton,
    ...pages,
    ...experiments,
    ...categories,
    ...institutions,
    ...chatbot,
    ...versions,
    ...roles,
    ...logs,
    ...lms,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})
loadDynamicCategoryRoutes(router)
router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  if (to.name === 'auth-login') {
    return next()
  }
  const redirectLogin = to.meta.breadcrumb ? to.meta.breadcrumb[0].redirectIfLoggedIn : true
  if (!canNavigate(to)) {
    if (!isLoggedIn && redirectLogin) return next({ name: 'auth-login', query: to.query })
    return next()
  }
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  // Check user status on every navigation to catch deactivated users
  if (isLoggedIn) {
    store.dispatch('users/profile').catch(() => {
      // Error handled by request.js interceptor
    })
  }

  return next()
})

router.afterEach(() => {
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export async function loadDynamicCategoryRoutes(router) {
  try {
    const response = await store.dispatch('categories/categoryLookups')
    const categoryList = response.data || response
    const dynamicRoutes = categoryList.map(category => ({
      path: `/filter/${category.id}`,
      name: `filter_${category.id}`,
      component: Home,
      meta: {
        breadcrumb: [
          { text: category.name, active: true },
        ],
      },
    }))
    const newRoutes = [...router.options.routes, ...dynamicRoutes]
    router.matcher = new VueRouter({
      mode: 'history',
      base: process.env.BASE_URL,
      routes: newRoutes,
    }).matcher
  } catch (error) {
    console.log('error ===> ', error)
  }
}

// store.watch(
//   (state) => state.categories?.lookups,
//   async () => {
//     await loadDynamicCategoryRoutes(router)
//   }
// )
export default router
